import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ShellContextService } from 'app/services/shell-context/shell-context.service';
import { map, take } from 'rxjs';
import { GlobalSettingsService } from '@core/globalSettings.service';
import { TimberService } from '@logging/timber.service';

/**
 * Prevents navigation to AOHS when no order context is available.
 * Redirects to the orders page if orderId, rxId, or patientId is missing.
 */
export const aohsContextGuard: CanActivateFn = () => {
	const shellContextService = inject(ShellContextService);
	const router = inject(Router);
	// eslint-disable-next-line deprecation/deprecation
	const globalSettingsService = inject(GlobalSettingsService);
	const timberService = inject(TimberService);

	return shellContextService.getContext().pipe(
		take(1),
		map(context => {
			const hasOrderContext = !!context?.bizCtx?.orderId && !!context?.bizCtx?.rxId && !!context?.bizCtx?.patientId;
			if (!hasOrderContext) {
				const roleType = globalSettingsService.rolePath();
				timberService.warn(`aohsContextGuard: redirecting to orders - missing order context (orderId=${context?.bizCtx?.orderId}, rxId=${context?.bizCtx?.rxId}, patientId=${context?.bizCtx?.patientId})`, { module: 'AohsContextGuard' });
				router.navigate([`${roleType}/orders`]);
				return false;
			}
			return true;
		})
	);
};
